module.exports = __webpack_public_path__ + "img/text3.a131a505.png";